import { useMemo } from 'react';
import { apiHelpers } from '../utils';

export function useQuoteExpiration(quotedata) {
  const { createdAt, status } = quotedata || {};
  return useMemo(() => {
    return apiHelpers.getQuoteExpiration({ createdAt, status });
  }, [createdAt, status]);
}
